import { MapPin } from 'lucide-react';
import { useState } from 'react';
import { useHomeData } from '@/hooks/useHomeData';
import { Copyright } from '@/components/ui/Copyright';
import { resolveImagePath } from '@/utils/imageMap';

export function Footer() {
  const { homeData } = useHomeData();
  const [lightboxOpen, setLightboxOpen] = useState(false);

  return (
    <footer className="bg-secondary/10 py-12 mt-24">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {/* Contact Information */}
            <div className="text-center md:text-left">
              <h3 className="text-xl text-primary mb-6">{homeData.footer.companyName}</h3>
              
              {/* Location Information */}
              <div className="text-sm text-foreground/80">
                <p className="font-medium text-primary mb-2 flex items-center">
                  <MapPin size={16} className="mr-2" />
                  Location
                </p>
                <p>Minute Man Air Field (6B6)</p>
                <p>Hangar T2-1</p>
                <p>Stow, Massachusetts</p>
                <p className="mt-2 text-xs">Just 30 minutes west of Boston</p>
                
                {/* Hangar Directions Thumbnail */}
                <div className="mt-4">
                  <p className="text-xs text-primary/70 mb-2">Hangar Location on Airfield</p>
                  <button
                    onClick={() => setLightboxOpen(true)}
                    className="block hover:opacity-80 transition-opacity"
                    title="Click to view full-size hangar directions"
                  >
                    <img
                      src={resolveImagePath('/images/hangar-directions-thumb.jpg')}
                      alt="Hangar directions on airfield map"
                      className="rounded-md shadow-sm border w-full max-w-[200px]"
                    />
                  </button>
                  <p className="text-xs text-foreground/60 mt-1">Click to enlarge</p>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-lg overflow-hidden shadow-md">
              <iframe
                src={homeData.location.mapEmbedUrl}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Minute Man Air Field Map"
              ></iframe>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 border-t border-secondary/30">
            <Copyright showSeparator={false} />
          </div>
        </div>
      </div>

      {/* Lightbox for hangar directions */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
          onClick={() => setLightboxOpen(false)}
        >
          <div className="relative max-w-4xl max-h-[90vh]">
            <button
              onClick={() => setLightboxOpen(false)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 text-lg font-bold"
            >
              ✕ Close
            </button>
            <img
              src={resolveImagePath('/images/hangar-directions.jpg')}
              alt="Hangar directions on airfield map - full size"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </footer>
  );
}